import { Backdrop, CircularProgress } from '@mui/material';
import { Alert, ErrorScreen } from 'components/common';
import { useRole, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import React, {useEffect, useLayoutEffect, useState} from 'react'
import { useHistory, withRouter } from 'react-router-dom';
import RoleFormDumb from './RoleFormDumb';

const RoleEditSmart = (props) => {

  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const { cleanUpMessage, data, error, success, isLoaded ,putRole, getRol } = useRole();
  const { match: { params } } = props;
  const { roleId } = params;

  const [defaultValues, setDefaultValues] = useState({
    id: null,
    name: '',
    description: '',
    project: projects[0].value,
    permissions: []
  });

  const handleCloseAlert = () => cleanUpMessage();


  const handleEdit = (data) => {
    putRole({
      body: {...data},
    });
  };

  const handleData = () => {
    const screenData = data.find(d => {
      return d.roleId === Number(roleId)
    });
    let project = projects[0];
    if (screenData.permission && screenData.permission.length > 0) {
      const projectId = screenData.permission[0].projectId;
      project = projects.find(p => Number(p.value) === projectId);
      if (!project)
        project = projects[0];
    }
    setDefaultValues({
      id: screenData.roleId,
      name: screenData.roleName,
      description: screenData.roleDescription,
      project: project.value,
      permissions: screenData.permission
    })
  }

  useLayoutEffect(() => {
    getRol();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!!success.put) history.push(ROUTES.ROLE_LIST);
    else if (!!success.get) handleData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.put, success.get]);


  return (
    <>
    { error.get ?
      (
        <ErrorScreen />
      ): isLoaded.get ?
      (
        <Backdrop
        invisible
        sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
        open={true}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      ) : (projects) ?
      (
         <RoleFormDumb
          defaultValues={defaultValues}
          handleOnSubmit={handleEdit}
          isEdit={true}
        />
      ) : (
        <ErrorScreen />
      )
    }
    <Alert
      severity="error"
      handleClose={handleCloseAlert}
      open={error.put}
      message="common.errors.general.title" />
    </>
  )
}

export default withRequest(withRouter(RoleEditSmart));
